var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box/16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 156",
    d: "M2 4.16667V8.16667C2 8.57037 2.24274 8.93447 2.61538 9.08974L6 10.5M2 4.16667L5.23077 2.82051C5.72308 2.61538 6.27692 2.61538 6.76923 2.82051L8 3.33333M2 4.16667L4 5M6 5.83333V10.5M6 5.83333L10 4.16667M6 5.83333L4 5M6 10.5L9.38462 9.08974C9.75726 8.93447 10 8.57037 10 8.16667V4.16667M10 4.16667L8 3.33333M4 5L8 3.33333",
    stroke: "#AEBDCD",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/box_icon.6c7e64ab2ba7875d43a349610cd702c3.svg";
export { ForwardRef as ReactComponent };